import React, {Component} from 'react';
import TooieModal from "../common/TooieModal.react.js";

let i18n = require("i18next");

export default class ChooseMemberModal extends Component {

    body() {
        let staffList = this.props.staffs.map(s =>
            <option value={s.id} data-authorities={s.authoritiesString} key={s.id}>{s.fullname}</option>
        );

        return (
            <div>
                <select className="form-control chooseStaff">
                    <option value='0'>---</option>
                    {staffList}
                </select>
            </div>
        );
    }

    footer() {
        return (
            <div className="modal-footer">
                <button className="btn chooseStaffBtn">{i18n.t("pos.order.confirm.yes")}</button>
            </div>
        );
    }

    render() {
        return (
            <TooieModal id="chooseMemberModal" title={i18n.t("pos.cashier.choose.waiter")} className="wide-modal"
                        footer={this.footer()}>
                {this.body()}
            </TooieModal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/react/modal/ChooseMemberModal.react.js